import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import { Ebooks, Courses } from "@/pages/Catalog";
import Faculty from "@/pages/Faculty";
import FAQs from "@/pages/FAQs";
import Testimonials from "@/pages/Testimonials";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import ThankYou from "@/pages/ThankYou";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminUploads from "@/pages/AdminUploads";
import AdminLeads from "@/pages/AdminLeads";
import LandingCharacter from "@/pages/LandingCharacter";
import CourseDetail from "@/pages/CourseDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Newsletter from "@/pages/Newsletter";
import NewsletterPost from "@/pages/NewsletterPost";
import AdminBlog from "@/pages/AdminBlog";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Redeem from "@/pages/Redeem";
import MagicLogin from "@/pages/MagicLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Unsubscribe from "@/pages/Unsubscribe";
import ExitIntentModal from "@/components/ExitIntentModal";
import useAnalytics from "@/hooks/useAnalytics";

const AnalyticsMount = () => { useAnalytics(); return null; };

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <AuthProvider>
        <CartProvider>
          <AnalyticsMount />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/ebooks" element={<Ebooks />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:productId" element={<CourseDetail />} />
              <Route path="/faculty" element={<Faculty />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/media" element={<Media />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/newsletter/:slug" element={<NewsletterPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin/uploads" element={<AdminUploads />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/character" element={<LandingCharacter />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/character-code-self-leadership" element={<LandingCharacter />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/redeem" element={<Redeem />} />
              <Route path="/magic-login" element={<MagicLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
          <ExitIntentModal />
        </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
